<template>
    <span @click="chooseBox(label,isDisabled)"
          :class="{changeColor:changeIndex === label,
          noChooseColor:chooseNoIndex === label,
          disabledColor:isDisabled}" class="check">
      O   {{label}}</span>
</template>

<script>
    export default {
      props:{
        label:String,
        value:Array,
        isDisabled:{type:Boolean,default:false},
      },
      data(){
        return{
          changeIndex:'',
          chooseNoIndex:''
        }
      },
      methods:{
        chooseBox(label,isDisabled){
          if(isDisabled === true){
            return;
          }
          let chooseList = this.$store.state.value;
          if(chooseList.indexOf(label)<=-1){// 不包含
            this.chooseNoIndex = '';
            this.changeIndex = label;
          }else{
            this.changeIndex = '';
            this.chooseNoIndex = label;
          }
          this.$store.commit('New_value',label);
          let chooseLists = this.$store.state.value;
          this.$emit('update:chooseList',chooseLists);
        }
      }
    }
</script>

<style scoped>
  .check{
    cursor: pointer;
  }
  .changeColor{
    color:blue;
  }
  .noChooseColor{
    color:#2c3e50;
  }
  .disabledColor{
    cursor:not-allowed;
    color:#ccc;

  }
</style>



// WEBPACK FOOTER //
// src/components/checkBox.vue